/**
 * Shared constants + small helpers for the Transactions page split.
 *
 * `emptyForm()` is a factory rather than a constant so each new
 * dialog open lands on today's ISO date, not the date the module
 * was imported.
 */
export const MS_PER_DAY = 86400000;

export const FREQUENCY_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'one_off', label: 'One-off' },
  { value: 'recurring', label: 'Recurring' },
  { value: 'transfer', label: 'Transfer' },
];

export const FREQUENCY_LABELS = {
  daily: 'Daily',
  weekly: 'Weekly',
  every_4_weeks: 'Every 4 weeks',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  annual: 'Annual',
  first_working_day_of_month: '1st working day of month',
  last_working_day_of_month: 'Last working day of month',
};

export const formatFrequency = (freq) => FREQUENCY_LABELS[freq] || (freq || '').replace(/_/g, ' ');

export const emptyForm = () => ({
  mechanic: 'one_off',
  account_id: '',
  date: new Date().toISOString().split('T')[0],
  description: '',
  amount: 0,
  transaction_type: 'expense',
  category: '',
  frequency: 'monthly',
  start_date: new Date().toISOString().split('T')[0],
  end_date: '',
  is_estimated: false,
  is_transfer: false,
  source_account_id: '',
  destination_account_id: '',
});
